import { Reveal } from "./Reveal";
import { BENEFITS } from "@/data";

export const Benefits = () => (
  <section id="benefits" className="bg-paper py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
        <Reveal className="lg:col-span-7">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-rust">The Difference</span>
          <h2 className="mt-5 font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            A garage that works as hard as the rest of your home.
          </h2>
        </Reveal>
        <Reveal className="lg:col-span-5" delay={0.1}>
          <p className="text-lg text-ink/60 leading-relaxed">
            For most homes it quietly becomes a catch-all — a room you step around more than step into.
            We reset it in a single visit and hand it back ready to use.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-ink/10 border border-ink/10">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.08}>
            <div data-testid={`benefit-${i}`} className="group bg-surface h-full p-8 hover:bg-cream transition-colors duration-300 border-t-2 border-transparent hover:border-rust">
              <span className="font-mono text-xs uppercase tracking-widest text-rust">{b.tag}</span>
              <h3 className="mt-6 font-display font-bold text-2xl text-ink transition-colors">
                {b.title}
              </h3>
              <p className="mt-3 text-ink/60 leading-relaxed">{b.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
